import * as cn from 'classnames'
import { PureComponent, ReactNode } from 'react'
import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import InternalSidebarContainer from 'components/features/pfm/InternalSidebar/InternalSidebarContainer'
import * as styles from 'styles/layouts/Layouts.css'
import withReadyEvent from 'hocs/withReadyEvent/withReadyEvent'

type SidebarLayoutOwnProps = {
  body?: ReactNode
  sidebar?: ReactNode
  sidebarRight?: boolean
}

type SidebarLayoutStateProps = {
  sidebarTopLayer: boolean
}

type SidebarLayoutProps = SidebarLayoutOwnProps & SidebarLayoutStateProps

class SidebarLayoutComponent extends PureComponent<SidebarLayoutProps> {
  render () {
    const { children, body, sidebar, sidebarTopLayer, sidebarRight } = this.props

    const main = (
      <main className={ styles.main }>
        { body || children }
      </main>
    )

    const aside = (
      <aside className={ styles.aside }>
        { sidebar || <InternalSidebarContainer /> }
      </aside>
    )

    const className = cn(styles.sidebarLayout, { [styles.sidebarTopLayer]: sidebarTopLayer })

    return (
      <div className={ className }>
        { sidebarRight ? main : aside }
        { sidebarRight ? aside : main }
      </div>
    )
  }
}

const SidebarLayout = connect<SidebarLayoutStateProps, {}, SidebarLayoutOwnProps>(
  (state: State): SidebarLayoutProps => {
    const { shownPane, peergroupPopup } = state.app.sidebar

    return {
      sidebarTopLayer: shownPane === 'form' || Boolean(peergroupPopup.relationId),
    }
  }
)(SidebarLayoutComponent)

export default withReadyEvent(SidebarLayout)
